import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { 
  Messages,
  Conversation,
  GroupConversation
} from '@screens';
import { AddConversation } from '../../screens/messages/addConversation';
import { ConversationParams } from '@screens';

export type MessagesStackParamList = {
  MessagesChat: undefined;
  AddConversation: undefined;
  Conversation: ConversationParams;
  GroupConversation: ConversationParams;
};

const Stack = createNativeStackNavigator<MessagesStackParamList>();

const MessagesStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen 
        name="MessagesChat" 
        component={Messages} 
      />
      <Stack.Screen 
        name="AddConversation" 
        component={AddConversation} 
      />
      <Stack.Screen 
        name="Conversation" 
        component={Conversation} 
      />
      <Stack.Screen 
        name="GroupConversation" 
        component={GroupConversation} 
      />
    </Stack.Navigator>
  );
};

export default MessagesStackNavigator; 